import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_a3fa1a3c from 'nuxt_plugin_plugin_a3fa1a3c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_yandexmetrikaplugin1ed6101e_43da6ba6 from 'nuxt_plugin_yandexmetrikaplugin1ed6101e_43da6ba6' // Source: ./yandex-metrika.plugin.1ed6101e.js (mode: 'client')
import nuxt_plugin_googletagmanager_2c0c4f7a from 'nuxt_plugin_googletagmanager_2c0c4f7a' // Source: ./google-tag-manager.js (mode: 'client')
import nuxt_plugin_pluginrouting_3f5f24ce from 'nuxt_plugin_pluginrouting_3f5f24ce' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7c62a961 from 'nuxt_plugin_pluginmain_7c62a961' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_22a990a0 from 'nuxt_plugin_cookieuniversalnuxt_22a990a0' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuechimera_4c1e564a from 'nuxt_plugin_vuechimera_4c1e564a' // Source: ./vue-chimera.js (mode: 'all')
import nuxt_plugin_axios_b23e3e10 from 'nuxt_plugin_axios_b23e3e10' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_19cbe616 from 'nuxt_plugin_nuxtsvgsprite_19cbe616' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_scrolllock_d3129cfa from 'nuxt_plugin_scrolllock_d3129cfa' // Source: ../plugins/scroll-lock.js (mode: 'all')
import nuxt_plugin_numberFormat_553960a0 from 'nuxt_plugin_numberFormat_553960a0' // Source: ../plugins/numberFormat.js (mode: 'all')
import nuxt_plugin_cursorAnchor_069d3bb5 from 'nuxt_plugin_cursorAnchor_069d3bb5' // Source: ../plugins/cursorAnchor.js (mode: 'all')
import nuxt_plugin_vueplyr_9c446a5a from 'nuxt_plugin_vueplyr_9c446a5a' // Source: ../plugins/vue-plyr (mode: 'all')
import nuxt_plugin_vuemask_9c4778ac from 'nuxt_plugin_vuemask_9c4778ac' // Source: ../plugins/vue-mask (mode: 'all')
import nuxt_plugin_absoluteImageUrl_057c8682 from 'nuxt_plugin_absoluteImageUrl_057c8682' // Source: ../plugins/absoluteImageUrl (mode: 'all')
import nuxt_plugin_i18n_56ca5e75 from 'nuxt_plugin_i18n_56ca5e75' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_vuetippy_d1cfcd5e from 'nuxt_plugin_vuetippy_d1cfcd5e' // Source: ../plugins/vue-tippy.js (mode: 'all')
import nuxt_plugin_intersectionobserver_36770e18 from 'nuxt_plugin_intersectionobserver_36770e18' // Source: ../plugins/intersection-observer.js (mode: 'all')
import nuxt_plugin_crmb24_3aa85418 from 'nuxt_plugin_crmb24_3aa85418' // Source: ../plugins/crm-b24.js (mode: 'all')
import nuxt_plugin_scrollto_61272a90 from 'nuxt_plugin_scrollto_61272a90' // Source: ../plugins/scroll-to.js (mode: 'all')
import nuxt_plugin_vscrollto_09f01187 from 'nuxt_plugin_vscrollto_09f01187' // Source: ../plugins/v-scroll-to.js (mode: 'all')
import nuxt_plugin_vuetouch_ebd58b7e from 'nuxt_plugin_vuetouch_ebd58b7e' // Source: ../plugins/vue-touch (mode: 'client')
import nuxt_plugin_vueawesomeswiper_0e14f460 from 'nuxt_plugin_vueawesomeswiper_0e14f460' // Source: ../plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_vscrolllock_ac2b63d2 from 'nuxt_plugin_vscrolllock_ac2b63d2' // Source: ../plugins/v-scroll-lock.js (mode: 'client')
import nuxt_plugin_vclickoutside_b82aadfc from 'nuxt_plugin_vclickoutside_b82aadfc' // Source: ../plugins/v-click-outside.js (mode: 'all')
import nuxt_plugin_vuebar_04c3aad4 from 'nuxt_plugin_vuebar_04c3aad4' // Source: ../plugins/vuebar.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"MyTretyakov","script":[{"src":"\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id=GTM-TC35VHT&l=dataLayer","async":true}],"meta":[{"name":"yandex-verification","content":"440dda4e8b4dda45"},{"name":"yandex-verification","content":"21fb4bc2d708ab7c"},{"name":"google-site-verification","content":"KyGMaKnyWzqy8Hihy5TBRPxyjRd0l3TzDIph-txVGoc"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"og:description","name":"description","content":"Стань патроном произведения и открой его для всего мира с Государственной Третьяковской галереей!"},{"hid":"og:image-url","property":"og:image:url","content":"https:\u002F\u002Fmy.tretyakov.ru\u002Fimages\u002Fshare_old.jpg"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fmy.tretyakov.ru\u002Fimages\u002Fshare_old.jpg"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"my.tretyakov.ru"}],"link":[{"rel":"icon","size":"16x16","href":".\u002Ffavicons\u002Ft_favico_16px.png"},{"rel":"icon","size":"32x32","href":".\u002Ffavicons\u002Ft_favico_32px.png"},{"rel":"icon","size":"180x180","href":".\u002Ffavicons\u002Ft_favico_180px_apple-touch-icon.png"},{"rel":"icon","size":"192x192","href":".\u002Ffavicons\u002Ft_favico_192px_android-chrome.png"},{"rel":"icon","size":"256x256","href":".\u002Ffavicons\u002Ft_favico_256px_android-chrome.png"},{"rel":"icon","size":"512x512","href":".\u002Ffavicons\u002Ft_favico_512px_android-chrome.png"},{"href":"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js","rel":"preload","as":"script"}],"style":[],"noscript":[{"hid":"gtm-noscript","innerHTML":"\u003Ciframe src=\"\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TC35VHT&l=dataLayer\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","pbody":true}],"__dangerouslyDisableSanitizersByTagID":{"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_a3fa1a3c === 'function') {
    await nuxt_plugin_plugin_a3fa1a3c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yandexmetrikaplugin1ed6101e_43da6ba6 === 'function') {
    await nuxt_plugin_yandexmetrikaplugin1ed6101e_43da6ba6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googletagmanager_2c0c4f7a === 'function') {
    await nuxt_plugin_googletagmanager_2c0c4f7a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3f5f24ce === 'function') {
    await nuxt_plugin_pluginrouting_3f5f24ce(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7c62a961 === 'function') {
    await nuxt_plugin_pluginmain_7c62a961(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_22a990a0 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_22a990a0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuechimera_4c1e564a === 'function') {
    await nuxt_plugin_vuechimera_4c1e564a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_b23e3e10 === 'function') {
    await nuxt_plugin_axios_b23e3e10(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_19cbe616 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_19cbe616(app.context, inject)
  }

  if (typeof nuxt_plugin_scrolllock_d3129cfa === 'function') {
    await nuxt_plugin_scrolllock_d3129cfa(app.context, inject)
  }

  if (typeof nuxt_plugin_numberFormat_553960a0 === 'function') {
    await nuxt_plugin_numberFormat_553960a0(app.context, inject)
  }

  if (typeof nuxt_plugin_cursorAnchor_069d3bb5 === 'function') {
    await nuxt_plugin_cursorAnchor_069d3bb5(app.context, inject)
  }

  if (typeof nuxt_plugin_vueplyr_9c446a5a === 'function') {
    await nuxt_plugin_vueplyr_9c446a5a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_9c4778ac === 'function') {
    await nuxt_plugin_vuemask_9c4778ac(app.context, inject)
  }

  if (typeof nuxt_plugin_absoluteImageUrl_057c8682 === 'function') {
    await nuxt_plugin_absoluteImageUrl_057c8682(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_56ca5e75 === 'function') {
    await nuxt_plugin_i18n_56ca5e75(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetippy_d1cfcd5e === 'function') {
    await nuxt_plugin_vuetippy_d1cfcd5e(app.context, inject)
  }

  if (typeof nuxt_plugin_intersectionobserver_36770e18 === 'function') {
    await nuxt_plugin_intersectionobserver_36770e18(app.context, inject)
  }

  if (typeof nuxt_plugin_crmb24_3aa85418 === 'function') {
    await nuxt_plugin_crmb24_3aa85418(app.context, inject)
  }

  if (typeof nuxt_plugin_scrollto_61272a90 === 'function') {
    await nuxt_plugin_scrollto_61272a90(app.context, inject)
  }

  if (typeof nuxt_plugin_vscrollto_09f01187 === 'function') {
    await nuxt_plugin_vscrollto_09f01187(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetouch_ebd58b7e === 'function') {
    await nuxt_plugin_vuetouch_ebd58b7e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_0e14f460 === 'function') {
    await nuxt_plugin_vueawesomeswiper_0e14f460(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vscrolllock_ac2b63d2 === 'function') {
    await nuxt_plugin_vscrolllock_ac2b63d2(app.context, inject)
  }

  if (typeof nuxt_plugin_vclickoutside_b82aadfc === 'function') {
    await nuxt_plugin_vclickoutside_b82aadfc(app.context, inject)
  }

  if (typeof nuxt_plugin_vuebar_04c3aad4 === 'function') {
    await nuxt_plugin_vuebar_04c3aad4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
